import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { array, bool, func, object, string, instanceOf } from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import { addRegisterLocale } from '../../../i18n';
import useConnect from './hooks';
import useStyles from './styles';
import Tooltip from '../../Tooltip';
import messages from './messages';

const MyDatePicker = ({
  className,
  disabled,
  formik,
  icon,
  id,
  includeDates,
  includeTimes,
  intl,
  label,
  name,
  onChange,
  placeholder,
  tooltip,
  inputProps,
  minDate,
  maxDate,
  variant = 'date',
  showTime,
  filterTime,
}) => {
  const { locale } = useConnect();
  const classes = useStyles();

  addRegisterLocale(locale);

  return (
    <Grid container name={name} className={className} alignItems="flex-end" style={{ width: '100%' }} wrap="nowrap">
      <Grid item className={classes.align}>
        <Icon component={icon} className="icon" color="secondary" style={{ fontSize: '18px', marginRight: 10 }} />
      </Grid>
      <Grid item className={classes.datePickerWrapper}>
        {
          {
            date: (
              <DatePicker
                customInput={
                  <TextField fullWidth label={<FormattedMessage {...label} />} InputLabelProps={{ shrink: true }} />
                }
                dateFormat={showTime ? 'Pp' : 'P'}
                showTimeSelect={showTime}
                timeFormat={showTime && 'h:mm a'}
                disabled={disabled}
                includeDates={includeDates}
                locale={locale}
                onChange={onChange}
                placeholderText={intl.formatMessage(placeholder)}
                selected={formik.values[id]}
                minDate={minDate}
                maxDate={maxDate}
                filterTime={filterTime}
              />
            ),
            time: (
              <DatePicker
                customInput={
                  <TextField
                    fullWidth
                    label={<FormattedMessage {...label} />}
                    InputLabelProps={{ shrink: true }}
                    InputProps={inputProps}
                  />
                }
                dateFormat="HH:mm"
                disabled={disabled}
                includeTimes={includeTimes}
                locale={locale}
                onChange={onChange}
                placeholderText={intl.formatMessage(placeholder)}
                selected={formik.values[id]}
                showTimeSelect
                showTimeSelectOnly
                timeCaption={<FormattedMessage {...messages.timeCaption} />}
                timeFormat="HH:mm"
                timeIntervals={30}
              />
            ),
          }[variant]
        }
      </Grid>
      <Grid item>{tooltip && <Tooltip content={tooltip.content} trackingEvent={tooltip.trackingEvent} />}</Grid>
    </Grid>
  );
};

MyDatePicker.propTypes = {
  className: string,
  disabled: bool,
  formik: object,
  icon: object,
  id: string,
  includeDates: array,
  includeTimes: array,
  intl: object,
  label: object,
  name: string,
  onChange: func,
  placeholder: object,
  tooltip: object,
  variant: string,
  inputProps: object,
  minDate: instanceOf(Date),
  maxDate: instanceOf(Date),
  showTime: bool,
  filterTime: func,
};

export default injectIntl(MyDatePicker);
